import React,{ useState } from 'react';
import { connect } from 'react-redux';
import '../../scss/partials/assignDevices/assignDevices.css';
import ReactPaginate from 'react-paginate';

export function UnConnectedUnmatchedDevicesList(props){
  const {data} = props;

  const [currentPage, setCurrentPage] = useState(0);

  const [pagerParams, setPagerParams] = useState({
        totalLength: 0,
        startValue: 0,
        endValue: 10,
        incrementValue: 10,
        totalPages:0,
    });

  const [searchFilter, setSearchFilter] = useState('');
  const handleSearchFilter = (event) => {
    const value = event.target.value;
    const pagerValues = { ...pagerParams };
    pagerValues.startValue = 0;
    setCurrentPage(0);
    setSearchFilter(value);
  };
    
  function handlePageChange({selected}){
    const pagerValues = {...pagerParams};
    let total = pagerValues.totalLength;
    let startTemp = selected * pagerParams.incrementValue;
    let endTemp = startTemp + pagerParams.incrementValue > total ? total : startTemp + pagerParams.incrementValue;
    pagerValues.startValue = startTemp;
    pagerValues.endValue = endTemp;
    setCurrentPage(selected);
    setPagerParams(pagerValues);
  }  

  function displayTable(){
    let searchedDevices = [];

    if (searchFilter !== '') {
      searchedDevices = data.filter((category) => {
      let filterResult = false;
      const searchText = searchFilter.toUpperCase();

      const categoryDescription = category.cateDesc.toUpperCase();
      
      if(categoryDescription.includes(searchText)){
        filterResult = true;
      }else{
        filterResult = category.matchdevices.some((device)=>{
          let tempResult = false;
          const deviceDescription = device.deviceDesc.toUpperCase();
          if(deviceDescription.includes(searchText)){
            tempResult = true;
          }
        return tempResult;
        });
      } 
      return filterResult;
      });
      } else {
        searchedDevices = data;
      }

      if (searchedDevices.length !== pagerParams.totalLength) {
        const pagerValues = { ...pagerParams };
        let startTemp = currentPage * pagerParams.incrementValue;
        let endTemp = startTemp + pagerParams.incrementValue > searchedDevices.length ? searchedDevices.length : startTemp + pagerParams.incrementValue;
        pagerValues.totalLength = searchedDevices.length;
        pagerValues.startValue = startTemp;
        pagerValues.endValue = endTemp;
        pagerValues.totalPages = Math.ceil(searchedDevices.length/pagerParams.incrementValue);
        setPagerParams(pagerValues);
      }

      
    let pagedDevices = searchedDevices.slice(pagerParams.startValue,pagerParams.endValue);
      
    return(
    <table className="tabletag width-100" data-test="table">
      <thead>
        <tr>
          <td className="table_head_row text-bold width-40" data-test="table-head">{"Category"}</td>
          <td className="table_head_row text-bold width-50" data-test="table-head">{"Device Description"}</td>
        </tr>
      </thead>
      <tbody>
        {pagedDevices.map((eachCategory, index) => {
          return(
          <React.Fragment>
          <tr data-test="table-row">
            <td rowSpan={eachCategory.matchLength} className={index % 2 ? "table__row table__row--alternate align-top": "table__row align-top"}>{eachCategory.cateDesc}</td>
            <td className={index % 2 ? "table__row table__row--alternate": "table__row"}>{eachCategory.matchdevices[0].deviceDesc}</td>
          </tr>
          {eachCategory.matchdevices.map((match, indx)=>{
            if(indx === 0){
              return '';
            }
            return(
              <tr>
                <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>{match.deviceDesc}</td>
              </tr>);
            })}
          </React.Fragment>
          );
        })}
      </tbody>
    </table>
    );
  }

  return(
    <React.Fragment>
      <div className="flex-spread width-100">
        <div className="center-self">
          <input type="textbox" 
          data-test="searchBox"
          className="message-table__filter-search-box search_bg"
          onChange={handleSearchFilter}
          value={searchFilter}
          />
        </div>
        {pagerParams.totalLength > 0 ? (
        <div className="react-paginate " data-test="react-paginate">
          <ReactPaginate previousLabel={'Prev'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={pagerParams.totalPages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={2}
            onPageChange={handlePageChange}
            activeClassName={'active'}
            forcePage={currentPage}
          />
        </div>
        ) : ('')}
     </div>
     <p></p>
      {displayTable()}
      <div className="container_2-column margin-top-10">
      {pagerParams.totalLength > 0 ? (<div className="text-large placeend"><strong>{pagerParams.startValue+1}</strong> - <strong>{pagerParams.endValue}</strong> of <strong>{pagerParams.totalLength}</strong> { pagerParams.totalLength >1 ? "Categories" : "Category"}</div>):('')}
      {pagerParams.totalLength > 0 ? (
      <div className="react-paginate placeend" data-test="react-paginate">
        <ReactPaginate previousLabel={'Prev'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pagerParams.totalPages}
          marginPagesDisplayed={1}
          pageRangeDisplayed={2}
          onPageChange={handlePageChange}
          activeClassName={'active'}
         forcePage={currentPage}
        />
      </div>
      ) : ('')}
      </div>
    </React.Fragment>
    );
}

export default connect()(UnConnectedUnmatchedDevicesList);